/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseVirtualBrandsInnerDeliveryConfig
 */
export interface GetConfig200ResponseVirtualBrandsInnerDeliveryConfig {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseVirtualBrandsInnerDeliveryConfig
     */
    locationVirtualBrandId: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseVirtualBrandsInnerDeliveryConfig
     */
    preparationMinutes: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseVirtualBrandsInnerDeliveryConfig
     */
    schedulingMarginMinutes: number | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseVirtualBrandsInnerDeliveryConfig interface.
 */
export function instanceOfGetConfig200ResponseVirtualBrandsInnerDeliveryConfig(value: object): value is GetConfig200ResponseVirtualBrandsInnerDeliveryConfig {
    if (!('locationVirtualBrandId' in value) || value['locationVirtualBrandId'] === undefined) return false;
    if (!('preparationMinutes' in value) || value['preparationMinutes'] === undefined) return false;
    if (!('schedulingMarginMinutes' in value) || value['schedulingMarginMinutes'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseVirtualBrandsInnerDeliveryConfigFromJSON(json: any): GetConfig200ResponseVirtualBrandsInnerDeliveryConfig {
    return GetConfig200ResponseVirtualBrandsInnerDeliveryConfigFromJSONTyped(json, false);
}

export function GetConfig200ResponseVirtualBrandsInnerDeliveryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseVirtualBrandsInnerDeliveryConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'locationVirtualBrandId': json['locationVirtualBrandId'],
        'preparationMinutes': json['preparationMinutes'],
        'schedulingMarginMinutes': json['schedulingMarginMinutes'],
    };
}

export function GetConfig200ResponseVirtualBrandsInnerDeliveryConfigToJSON(json: any): GetConfig200ResponseVirtualBrandsInnerDeliveryConfig {
    return GetConfig200ResponseVirtualBrandsInnerDeliveryConfigToJSONTyped(json, false);
}

export function GetConfig200ResponseVirtualBrandsInnerDeliveryConfigToJSONTyped(value?: GetConfig200ResponseVirtualBrandsInnerDeliveryConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationVirtualBrandId': value['locationVirtualBrandId'],
        'preparationMinutes': value['preparationMinutes'],
        'schedulingMarginMinutes': value['schedulingMarginMinutes'],
    };
}

